import '../../styles.global.css';
import '../../assets/styles/ClanRole.module.css';

var styles = {"role":"wru__ClanRole__role","isLarger":"wru__ClanRole__isLarger","commander":"wru__ClanRole__commander wru__ClanRole__role","executive_officer":"wru__ClanRole__executive_officer wru__ClanRole__role","recruitment_officer":"wru__ClanRole__recruitment_officer wru__ClanRole__role","commissioned_officer":"wru__ClanRole__commissioned_officer wru__ClanRole__role","officer":"wru__ClanRole__officer wru__ClanRole__role","private":"wru__ClanRole__private wru__ClanRole__role"};

export { styles as default };
//# sourceMappingURL=ClanRole.module.scss.js.map
